import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $recipientByIdStore } from '@lib/store';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { RecipientInfo, RecipientsDetails, RecipientTransaction } from './widgets';
import { Icon, PageContainer, Text } from '@shared/widgets';
import ArrowIcon from '@assets/icons/arrow.svg';
import ArrowVCFCIcon from '@assets/icons/arrow-vcfc.svg';

export const RecipientPage = () => {
  const { id } = useParams();

  const recipientGetById = useUnit($recipientByIdStore.store);

  const { t } = useTranslation('recipient');

  useEffect(() => {
    if (!id) return;
    $recipientByIdStore.events.getById(id);
    return () => $recipientByIdStore.events.clear();
  }, [id]);

  return (
    <PageContainer
      loading={recipientGetById.loading}
      title={t('title')}
      header={
        <Link className='group flex items-center gap-2' to={RoutePaths.payments.onNavigate()}>
          <Icon
            icon={PaletteUtils.isInsigniaPalette ? <ArrowIcon /> : <ArrowVCFCIcon className='text-black dark:text-white' />}
            className={cn(PaletteUtils.isInsigniaPalette && 'rotate-180')}
          />
          {PaletteUtils.isInsigniaPalette ? (
            <Text weight='semibold' size='2xl'>
              {t('header')}
            </Text>
          ) : (
            <Text className='group-hover:underline' size='sm'>
              {t('return')}
            </Text>
          )}
        </Link>
      }
    >
      {recipientGetById.data && (
        <div className='flex items-stretch gap-6'>
          <div className='flex min-w-64 flex-1 flex-col gap-8'>
            <RecipientInfo recipient={recipientGetById.data} />
            <section
              className={cn(
                'flex flex-col gap-6',
                PaletteUtils.isVcfcPalette && 'rounded-xl bg-white p-7 dark:border dark:border-gray-black dark:bg-soft-black',
              )}
            >
              <Text weight='semibold' size='2xl'>
                {t('transaction.title')}
              </Text>
              <RecipientTransaction recipient={recipientGetById.data} />
            </section>
          </div>
          <aside className='min-w-64 flex-none grow-0 basis-[27%]'>
            <RecipientsDetails recipient={recipientGetById.data} />
          </aside>
        </div>
      )}
    </PageContainer>
  );
};
